import axios from 'axios';
import { handleApiError } from '../global/handleApiError';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchActiveSubsriptionForUserEmail = async (): Promise<string[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/subscription/active`, {
      withCredentials: true,
    });

    return response.data.distributionLists;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return [];
    } else {
        throw error;
    }
  }
};

export const subscribeUserEmailforList = async (listName: string, csrfToken: string | null): Promise<void> => {
  if (!csrfToken) throw new Error("CSRF token not available");
  try {
    const response = await axios.post(`${API_BASE_URL}/subscription/${listName}/subscribe`, {},{
      headers: { 
        'CSRF-Token': csrfToken, 
      },
      withCredentials: true, 
    });
    return response.data.message;
  } catch (error) {
    throw new Error(handleApiError(error));
  }
};

export const unSubscribeUserEmailforList = async (listName: string, csrfToken: string | null): Promise<void> => {
  if (!csrfToken) throw new Error("CSRF token not available");
  try {
    const response = await axios.delete(`${API_BASE_URL}/subscription/${listName}/unsubscribe`, {
      headers: { 
        'CSRF-Token': csrfToken, 
      },
      withCredentials: true, // Include cookies (e.g., connect.sid)
    });
    return response.data.message;
  } catch (error) {
    throw new Error(handleApiError(error));
  }
};